/**
 * SNMP 설정
 *
 * @since 2018-11-23
 * @author jupil.Go <devp018>
 */

import {i18n} from '~/plugins/i18n'
import {CmApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  errorMessage: null,
  url: `${apiPrefix}/snmp-cm`,
  REST_URL: {
    user: `${apiPrefix}/snmp-cm/user`,
    v3: `${apiPrefix}/snmp-cm/v3`,
    trap: `${apiPrefix}/snmp-cm/trap`
  },
  selectedItem: {},
  snmpDataList: [],
  snmpPageOrgData: {},
  snmpPageData: {
    device_list: [],
    snmp_cm_id: 0,
    snmp_cm_sync_yn: 1,
    snmp_cm_use_yn: 1,
    snmp_cm_uname: '',
    snmp_cm_desc: '',
    snmp_cm_cmmnt_name: '',
    // snmp_cm_sender_sync_yn: 0,
    // snmp_cm_sender_ip: '',
    // snmp_cm_sender_ip_ver_type: 0,
    // snmp_cm_log_sync_set: [],
    snmp_cm_log_set: [],
    snmp_cm_log_opt_set: [],
    device_id_list: [],
    device_list_name: '',
    snmp_cm_device_model_type: 20
  },
  selectedSendItems: {},
  // SNMP 사용자 설정
  snmpUserPwList: [],
  snmpUserList: [],
  snmpUserData: {
    snmp_cm_id: 0,
    snmp_cm_user_id: null,
    snmp_cm_user_auth_pw: '',
    snmp_cm_user_auth_type: 0,
    snmp_cm_user_enc_pw: '',
    snmp_cm_user_enc_type: 0,
    snmp_cm_user_name: '',
    snmp_cm_user_server_uname: '',
    snmp_cm_user_type: 0
  },
  // SNMP V3 설정
  selectSnmpV3: {
    snmp_cm_v3_use_yn: 0,
    snmp_cm_user_id: null
  },
  snmpV3SettingList: [],
  snmpV3SettingData: {
    snmp_cm_user_id: null,
    snmp_cm_v3_use_yn: 0,
    snmp_cm_user_server_uname: 'test1',
    snmp_cm_user_name: 'admin'
  },
  // SNMP TRAP 설정
  snmpTrapList: [],
  snmpTrapData: {
    snmp_cm_trap_id: 1,
    snmp_cm_id: 0,
    snmp_cm_trap_use_yn: 0, //           required (one of 0, 1 - default: 0) SNMP TRAP 사용 유무 사용안함: 0, 사용: 1
    snmp_cm_trap_addr_val: '', //         required (string) SNMP 수신지 IP
    snmp_cm_trap_port: 0, //          required (integer - default: 0) SNMP 수신지 Port
    snmp_cm_trap_cmmnt_name: '', //    required (string) 수신지 Community
    snmp_cm_trap_type: 1, //           required (one of 1, 2, 3 - default: 1) SNMP 버전 1: 1, 2c: 2, 3: 3
    snmp_cm_user_id: null, //   required (integer) SNMP 사용자 고유 ID
    snmp_cm_trap_desc: '' //         required (string) 설명
  },
  // ///////////////////////////////////////
  logInfoList: [],
  defaultList: [],
  defaultOptionList: [],
  syncData: {}
})

export const mutations = {
  init (state) {
    state.snmpDataList = []
  },
  initPopUp (state) {
    state.snmpUserList = []
    state.snmpUserPwList = []
    state.snmpV3SettingList = []
    // state.snmpV3SettingData = {}
    state.snmpTrapList = []
    // state.snmpTrapData = {}
    state.logInfoList = []
    state.defaultList = []
    state.defaultOptionList = []
    // state.syncData = {}
  },
  setErrorMessage (state, data) {
    const msg = _.isNil(data.msg) ? '' : {
      error: data.msg
    }
    state.errorMessage = msg
  },
  setSnmpLogEntitiesSettings (state, payload) {
    state.snmpPageData.snmp_cm_log_set = payload

    state.defaultList = state.snmpPageData.snmp_cm_log_set
    state.logInfoList = _.cloneDeep(state.defaultList)
  },
  // 리스트 조회
  setSnmpData (state, item) {
    // state.logInfoList = []
    state.snmpDataList = item.map(o => {
      const listLength = _.size(o.device_list)
      let
        list = [],
        listName = ''
      if (listLength > 0) {
        list = o.device_list.map(id => id.device_id)
        listName = (listLength > 1) ? i18n.t('cmn.deviceTypeText', {name: o.device_list[0].device_uname, cnt: listLength - 1}) : o.device_list[0].device_uname
      }
      return _.assign(o, { 'device_id_list': list, 'device_list_name': listName })
    })
  },
  addSnmp: (state, item) => {
    state.snmpDataList.push(item)
  },
  delSnmp: (state, itemList) => {
    for (const itemKey of itemList.snmp_cm_id_list) {
      const idx = _.findIndex(state.snmpDataList, {snmp_cm_id: itemKey})
      if (idx >= 0) {
        state.snmpDataList.splice(idx, 1)
      }
    }
  },
  setSnmpDialog (state, data) {
    state.selectedItem = data
    const snmpData = _.cloneDeep(data)
    state.snmpPageData.snmp_cm_id = snmpData.snmp_cm_id
    state.snmpPageData.snmp_cm_uname = snmpData.snmp_cm_uname
    state.snmpPageData.snmp_cm_desc = snmpData.snmp_cm_desc
    state.snmpPageData.snmp_cm_sync_yn = snmpData.snmp_cm_sync_yn
    state.snmpPageData.snmp_cm_use_yn = snmpData.snmp_cm_use_yn
    // state.snmpPageData.snmp_cm_sender_ip = data.snmp_cm_sender_ip
    state.snmpPageData.snmp_cm_cmmnt_name = snmpData.snmp_cm_cmmnt_name
    // state.snmpPageData.snmp_cm_log_sync_set = JSON.parse(data.snmp_cm_log_sync_set)
    state.snmpPageData.snmp_cm_log_set = JSON.parse(snmpData.snmp_cm_log_set)
    state.snmpPageData.device_id_list = _.isUndefined(snmpData.device_id_list) ? [] : snmpData.device_id_list
    state.snmpPageData.device_list_name = _.isUndefined(snmpData.device_list_name) ? [] : snmpData.device_list_name

    state.snmpPageData.snmp_cm_device_model_type = snmpData.snmp_cm_device_model_type

    state.defaultList = state.snmpPageData.snmp_cm_log_set
    state.logInfoList = _.cloneDeep(state.defaultList)
    // state.syncData = setSyncData(state.snmpPageData.snmp_cm_log_sync_set)

    state.snmpPageData.snmp_cm_log_opt_set = JSON.parse(snmpData.snmp_cm_log_opt_set)
    state.defaultOptionList = state.snmpPageData.snmp_cm_log_opt_set
  },
  setSnmpOptionList (state, data) {
    state.snmpPageData.snmp_cm_log_opt_set = _.cloneDeep(data)
    state.defaultOptionList = _.cloneDeep(state.snmpPageData.snmp_cm_log_opt_set)
  },
  clearSnmpDialog: (state) => {
    delete state.snmpPageData.snmp_cm_id
    state.snmpPageData.snmp_cm_uname = ''
    state.snmpPageData.snmp_cm_desc = ''
    state.snmpPageData.snmp_cm_sync_yn = 1
    state.snmpPageData.snmp_cm_use_yn = 0
    // state.snmpPageData.snmp_cm_sender_ip = ''
    state.snmpPageData.snmp_cm_cmmnt_name = ''
    state.snmpPageData.snmp_cm_log_set = []
    state.snmpPageData.device_id_list = []
    state.snmpPageData.device_list_name = ''
    state.snmpPageData.snmp_cm_device_model_type = 20
  },
  resetSnmpPopUpData (state) {
    state.snmpUserList = []
    state.snmpUserPwList = []
    state.snmpV3SettingList = []
    state.snmpTrapList = []
  },
  // SNMP USER 조회
  setSnmpUserData (state, item) {
    state.snmpUserList = _.cloneDeep(item)
  },
  addSnmpUserData: (state, item) => {
    // 계속 기능 때문에
    state.snmpUserPwList.push({'snmp_cm_user_id': item.snmp_cm_user_id, 'snmp_cm_user_auth_pw': item.snmp_cm_user_auth_pw, 'snmp_cm_user_enc_pw': item.snmp_cm_user_enc_pw})
    delete item.snmp_cm_user_auth_pw
    delete item.snmp_cm_user_enc_pw
    state.snmpUserList.push(item)
  },
  edtSnmpUserData: (state, item) => {
    state.snmpUserList.splice(state.selectedSendItems.itemIndex, 1, item)
  },
  delSnmpUserData: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.snmpUserList, {snmp_cm_user_id: itemKey.snmp_cm_user_id})
      if (idx >= 0) {
        state.snmpUserList.splice(idx, 1)
      }
    }
  },
  setSnmpUserDialog: (state, data) => {
    state.selectedSendItems = data
    state.snmpUserData.snmp_cm_id = data.snmp_cm_id
    state.snmpUserData.snmp_cm_user_id = data.snmp_cm_user_id
    state.snmpUserData.snmp_cm_user_auth_pw = data.snmp_cm_user_auth_pw
    state.snmpUserData.snmp_cm_user_auth_type = data.snmp_cm_user_auth_type
    state.snmpUserData.snmp_cm_user_enc_pw = data.snmp_cm_user_enc_pw
    state.snmpUserData.snmp_cm_user_enc_type = data.snmp_cm_user_enc_type
    state.snmpUserData.snmp_cm_user_name = data.snmp_cm_user_name
    state.snmpUserData.snmp_cm_user_server_uname = data.snmp_cm_user_server_uname
    state.snmpUserData.snmp_cm_user_type = data.snmp_cm_user_type
  },
  clearSnmpUserDialog: (state, ccFlag) => {
    state.snmpUserData.snmp_cm_id = state.snmpPageData.snmp_cm_id
    state.snmpUserData.snmp_cm_user_id = null
    state.snmpUserData.snmp_cm_user_auth_pw = ''
    state.snmpUserData.snmp_cm_user_auth_type = 0
    state.snmpUserData.snmp_cm_user_enc_pw = ''
    state.snmpUserData.snmp_cm_user_enc_type = 0
    state.snmpUserData.snmp_cm_user_name = ''
    state.snmpUserData.snmp_cm_user_server_uname = ''
    state.snmpUserData.snmp_cm_user_type = ccFlag ? 2 : 0
  },
  // SNMP V3 조회
  setSnmpV3Data: (state, item) => {
    state.snmpV3SettingList = _.cloneDeep(item)
  },
  addSnmpV3Data: (state, item) => {
    state.snmpV3SettingList.push(item)
  },
  delSnmpV3Data: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.snmpV3SettingList, {snmp_cm_user_id: itemKey.snmp_cm_user_id})
      if (idx >= 0) {
        state.snmpV3SettingList.splice(idx, 1)
      }
    }
  },
  setSnmpV3Dialog: (state, item) => {
    // state.snmpV3SettingData = item
    state.snmpV3SettingData.snmp_cm_user_id = item.snmp_cm_user_id
    state.snmpV3SettingData.snmp_cm_v3_use_yn = item.snmp_cm_v3_use_yn
    state.snmpV3SettingData.snmp_cm_user_name = item.snmp_cm_user_name
    state.snmpV3SettingData.snmp_cm_user_server_uname = item.snmp_cm_user_server_uname
  },
  clearSnmpV3Dialog: (state) => {
    state.selectSnmpV3.snmp_cm_v3_use_yn = 0
    state.selectSnmpV3.snmp_cm_user_id = null
    state.snmpV3SettingData.snmp_cm_user_id = null
    state.snmpV3SettingData.snmp_cm_v3_use_yn = 0
    state.snmpV3SettingData.snmp_cm_user_name = ''
    state.snmpV3SettingData.snmp_cm_user_server_uname = ''

    state.snmpUserData.snmp_cm_id = state.snmpPageData.snmp_cm_id
    state.snmpUserData.snmp_cm_user_id = null
    state.snmpUserData.snmp_cm_user_auth_pw = ''
    state.snmpUserData.snmp_cm_user_auth_type = 0
    state.snmpUserData.snmp_cm_user_enc_pw = ''
    state.snmpUserData.snmp_cm_user_enc_type = 0
    state.snmpUserData.snmp_cm_user_name = ''
    state.snmpUserData.snmp_cm_user_server_uname = ''
    state.snmpUserData.snmp_cm_user_type = 0
  },
  // SNMP TRAP 조회
  setSnmpTrapData: (state, item) => {
    state.snmpTrapList = _.cloneDeep(item)
    // state.snmpTrapOriginData = _.cloneDeep(item)
  },
  setContinuedSnmpTrapData: (state, item) => {
    const cmId = _.cloneDeep(state.snmpPageData.snmp_cm_id)
    const newTrapIdList = _.map(_.orderBy(item, ['snmp_cm_trap_id'], ['asc']), 'snmp_cm_trap_id')
    state.snmpTrapList = _.map(state.snmpTrapList, o => {
      _.set(o, 'snmp_cm_id', cmId)
      const trapIndx = (o.snmp_cm_trap_id - 1) % 3
      _.set(o, 'snmp_cm_trap_id', newTrapIdList[trapIndx])
      return o
    })
  },
  edtSnmpTrapData: (state, item) => {
    const sidx = _.findIndex(state.snmpTrapList, {snmp_cm_trap_id: item.snmp_cm_trap_id})
    state.snmpTrapList.splice(sidx, 1, _.cloneDeep(item))
  },
  setSnmpTrapDialog: (state, data) => {
    state.selectedSendItems = data
    state.snmpTrapData.snmp_cm_trap_id = data.snmp_cm_trap_id
    state.snmpTrapData.snmp_cm_id = data.snmp_cm_id
    state.snmpTrapData.snmp_cm_trap_use_yn = data.snmp_cm_trap_use_yn
    state.snmpTrapData.snmp_cm_trap_addr_val = data.snmp_cm_trap_addr_val
    state.snmpTrapData.snmp_cm_trap_port = data.snmp_cm_trap_port
    state.snmpTrapData.snmp_cm_trap_cmmnt_name = data.snmp_cm_trap_cmmnt_name
    state.snmpTrapData.snmp_cm_trap_type = data.snmp_cm_trap_type
    state.snmpTrapData.snmp_cm_user_id = data.snmp_cm_user_id
    state.snmpTrapData.snmp_cm_trap_desc = data.snmp_cm_trap_desc

    state.snmpTrapData.snmp_cm_user_name = data.snmp_cm_user_name
    state.snmpTrapData.snmp_cm_user_server_uname = data.snmp_cm_user_server_uname
  },
  clearSnmpTrapDialog: (state) => {
    state.snmpTrapData.snmp_cm_trap_id = null
    state.snmpTrapData.snmp_cm_id = null
    state.snmpTrapData.snmp_cm_trap_use_yn = 0
    state.snmpTrapData.snmp_cm_trap_addr_val = ''
    state.snmpTrapData.snmp_cm_trap_port = null
    state.snmpTrapData.snmp_cm_trap_cmmnt_name = ''
    state.snmpTrapData.snmp_cm_trap_type = null
    state.snmpTrapData.snmp_cm_user_id = null
    state.snmpTrapData.snmp_cm_trap_desc = ''

    state.snmpTrapData.snmp_cm_user_name = ''
    state.snmpTrapData.snmp_cm_user_server_uname = ''
  },
  clearSnmpTrapList: (state) => {
    state.snmpUserList = []
    state.snmpV3SettingList = []
    state.snmpTrapList.forEach(item => {
      item.snmp_cm_trap_use_yn = 0
      item.snmp_cm_trap_addr_val = ''
      item.snmp_cm_trap_port = 162
      item.snmp_cm_trap_type = 1
      item.snmp_cm_trap_cmmnt_name = ''
      item.snmp_cm_user_server_uname = ''
      item.snmp_cm_user_name = ''
      item.snmp_cm_trap_desc = ''
    })
  }
}

export const actions = {
  // 리스트 조회
  async getSnmpData ({commit, state}, isShowLoading = true, id = 0) {
    const axiosParam = {
      loading: isShowLoading
    }
    const {code, result} = await this.$axios.$get(`${state.url}/${id}`, axiosParam)
    if (code === 'ok') {
      if (id === 0) { // 전체 조회
        commit('setSnmpData', result)
      } else { // 추가/편집 조회
        commit('setSnmpDialog', result)
      }
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async makeSnmp ({commit, state}, continued = false) {
    const {code, result} = await this.$axios.$post(state.url, null, {loading: false, successAlert: false})
    if (code === 'ok') {
      state.snmpPageData.snmp_cm_id = Number(result.msg)
      if (!continued) {
        const res = await this.$axios.$get(`${state.url}/${Number(result.msg)}`, {loading: false, successAlert: false})
        if (res.code === 'ok') {
          commit('setSnmpDialog', res.result[0])
        }
      // } else {
      //   commit('setSnmpDialog', _.cloneDeep(state.snmpPageData))
      }
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async addSnmp ({commit, state}, param) {
    const admParam = {
      device_id_list: _.map(state.snmpPageData.device_id_list),
      device_list_name: state.snmpPageData.device_list_name,
      snmp_cm_cmmnt_name: state.snmpPageData.snmp_cm_cmmnt_name,
      snmp_cm_desc: state.snmpPageData.snmp_cm_desc,
      snmp_cm_device_model_type: state.snmpPageData.snmp_cm_device_model_type,
      snmp_cm_id: state.snmpPageData.snmp_cm_id,
      snmp_cm_log_opt_set: JSON.stringify(state.snmpPageData.snmp_cm_log_opt_set),
      snmp_cm_log_set: JSON.stringify(state.logInfoList),
      snmp_cm_sync_yn: state.snmpPageData.snmp_cm_sync_yn,
      snmp_cm_uname: state.snmpPageData.snmp_cm_uname,
      snmp_cm_use_yn: state.snmpPageData.snmp_cm_use_yn
    }
    const {code, result} = await this.$axios.$put(state.url, admParam, {loading: false, successAlert: false})
    if (code === 'ok') {
      // dispatch('getSnmpData', false)
      if (!param.continued) {
        commit('clearSnmpDialog')
      }
      // else {
      //   state.snmpPageData.snmp_cm_log_set = JSON.stringify(state.logInfoList)
      //   state.snmpPageData.snmp_cm_log_opt_set = JSON.stringify(state.snmpPageData.snmp_cm_log_opt_set)
      //   // state.snmpPageData.snmp_cm_log_sync_set = JSON.parse(admParam.snmp_cm_log_sync_set)
      // }
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async edtSnmp ({commit, state}) {
    const param = _.cloneDeep(state.snmpPageData)
    param.snmp_cm_log_set = JSON.stringify(state.logInfoList)
    param.snmp_cm_log_opt_set = JSON.stringify(state.snmpPageData.snmp_cm_log_opt_set)
    // param.snmp_cm_log_sync_set = JSON.stringify(param.snmp_cm_log_sync_set)
    const {code, result} = await this.$axios.$put(state.url, param)
    if (code === 'ok') {
      // commit('edtSnmp', param)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async delSnmp ({commit, state}, param) {
    const isShow = _.has(param, 'isShow') ? param.isShow : true
    const isAlert = _.has(param, 'isAlert') ? param.isAlert : true
    const {code, result} = await this.$axios.$put(`${state.url}/multi`, param.idList, {loading: isShow, successAlert: isAlert, alertMsg: i18n.t('msg.removeApply')})
    if (code === 'ok') {
      commit('delSnmp', param.idList)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async initSnmpLogEntitiesSettings ({ commit, state }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.url}/log-set/${state.snmpPageData.snmp_cm_device_model_type}/init`, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'ok') {
        commit('setSnmpLogEntitiesSettings', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async processSnmpSync ({commit, state}, param) {
    const {code, result} = await this.$axios.$post(`${state.url}/multi`, param, {loading: false, isNotAlert: true})
    if (code === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  // 리스트 조회
  async getSnmpUserData ({commit, state}, continued = false, isShowLoading = false, userId = 0) {
    const axiosParam = {
      loading: isShowLoading,
      isNotAlert: false
    }
    const {code, result} = await this.$axios.$get(`${state.REST_URL.user}/${state.snmpPageData.snmp_cm_id}/${userId}`, axiosParam)
    if (code === 'ok') {
      if (userId === 0) { // 전체 조회
        if (!continued) {
          commit('setSnmpUserData', result)
        }
      } else { // 추가/편집 조회
        commit('setSnmpUserDialog', result)
      }
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async addSnmpUserData ({commit, state}, param) {
    const admParam = _.cloneDeep(state.snmpUserData)
    if (param.passwordAuth.length !== 0) {
      admParam.snmp_cm_user_auth_pw = param.passwordAuth
    } else {
      admParam.snmp_cm_user_auth_pw = null
    }
    if (param.passwordEnc.length !== 0) {
      admParam.snmp_cm_user_enc_pw = param.passwordEnc
    } else {
      admParam.snmp_cm_user_enc_pw = null
    }
    delete admParam.snmp_cm_user_id
    const {code, result} = await this.$axios.$post(state.REST_URL.user, admParam, {loading: false})
    if (code === 'ok') {
      admParam.snmp_cm_user_id = result.snmp_cm_user_id

      commit('addSnmpUserData', admParam)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async edtSnmpUserData ({commit, state}, param) {
    const edtParam = _.cloneDeep(state.snmpUserData)
    if (param.passwordAuth.length !== 0) {
      edtParam.snmp_cm_user_auth_pw = param.passwordAuth
    } else {
      edtParam.snmp_cm_user_auth_pw = null
    }
    if (param.passwordEnc.length !== 0) {
      edtParam.snmp_cm_user_enc_pw = param.passwordEnc
    } else {
      edtParam.snmp_cm_user_enc_pw = null
    }
    _.set(_.filter(state.snmpUserPwList, ['snmp_cm_user_id', edtParam.snmp_cm_user_id])[0], 'snmp_cm_user_auth_pw', edtParam.snmp_cm_user_auth_pw)
    _.set(_.filter(state.snmpUserPwList, ['snmp_cm_user_id', edtParam.snmp_cm_user_id])[0], 'snmp_cm_user_enc_pw', edtParam.snmp_cm_user_enc_pw)

    const {code, result} = await this.$axios.$put(state.REST_URL.user, edtParam)
    delete edtParam.snmp_cm_user_auth_pw
    delete edtParam.snmp_cm_user_enc_pw
    if (code === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async delSnmpUserData ({commit, state}, param) {
    try {
      const {code, result} = await this.$axios.$delete(`${state.REST_URL.user}/${param.items[0].snmp_cm_user_id}`)
      if (code === 'ok') {
        commit('delSnmpUserData', param)
        return true
      }
      commit('setErrorMessage', result)
    } catch (e) {}

    return false
  },
  // SNMP V3
  async getSnmpV3Data ({commit, state}) {
    const axiosParam = {
      loading: false,
      isNotAlert: false
    }
    try {
      const {code, result} = await this.$axios.$get(`${state.REST_URL.v3}/${state.snmpPageData.snmp_cm_id}`, axiosParam) // notUseLoadingParam)
      if (code === 'ok') {
        commit('setSnmpV3Data', result)
        return true
      }
      commit('setErrorMessage', result)
      return false
    } catch (e) {
      return false
    }
  },
  async addSnmpV3Data ({commit, state}, param) {
    const {code, result} = await this.$axios.$post(state.REST_URL.v3, param)
    if (code === 'ok') {
      commit('addSnmpV3Data', _.omit(state.snmpV3SettingData, ['itemIndex']))
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async edtSnmpV3Use ({commit, state}, param) {
    const {code, result} = await this.$axios.$post(`${state.REST_URL.v3}/multi`, param, {loading: false, isNotAlert: true})
    if (code === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async delSnmpV3Data ({commit, state}, param) {
    try {
      const delIdList = _.map(param.items, item => item.snmp_cm_user_id)
      const params = {
        snmp_cm_user_id_list: delIdList
      }
      const data = await this.$axios.$delete(`${state.REST_URL.v3}`, {data: params})
      if (data.code === 'ok') {
        commit('delSnmpV3Data', param)
        return true
      }
      return false
    } catch (e) {}
    return false
  },

  // SNMP TRAP
  async getSnmpTrapData ({commit, state}, continued = false, userId = 0) {
    const axiosParam = {
      loading: false,
      isNotAlert: false
    }
    try {
      const {code, result} = await this.$axios.$get(`${state.REST_URL.trap}/${state.snmpPageData.snmp_cm_id}/${userId}`, axiosParam) // notUseLoadingParam)
      if (code === 'ok') {
        if (!continued) {
          commit('setSnmpTrapData', result)
        } else {
          commit('setContinuedSnmpTrapData', result)
        }
        return true
      }
      commit('setErrorMessage', result)
      return false
    } catch (e) {
      return false
    }
  },
  async edtSnmpTrapData ({commit, state}) {
    const snmpTrapParam = _.cloneDeep(state.snmpTrapData)
    delete snmpTrapParam.snmp_cm_user_name
    delete snmpTrapParam.snmp_cm_user_server_uname
    const load = true
    const {code, result} = await this.$axios.$put(state.REST_URL.trap, snmpTrapParam, {loadingShow: load, loadingHide: load, successAlert: load})
    if (code === 'ok') {
      commit('edtSnmpTrapData', state.snmpTrapData)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async addSnmpDataAll ({commit, state}) {
    // _.flatten()
    let res = true
    const changeIdMapper = {}
    if (_.size(state.snmpUserList) > 0) {
      const userList = _.map(state.snmpUserList, item => {
        const merge = _.cloneDeep(_.filter(state.snmpUserPwList, ['snmp_cm_user_id', item.snmp_cm_user_id])[0])
        delete merge.snmp_cm_user_id
        item.snmp_cm_id = state.snmpPageData.snmp_cm_id
        // delete item.snmp_cm_user_id
        // _.omit(state.snmpV3SettingData, ['itemIndex']))
        return _.assign(item, merge)
      })
      const newSnmpUserList = []
      for (const admParam of userList) {
        const key = _.toString(admParam.snmp_cm_user_id)
        delete admParam.snmp_cm_user_id
        const {code, result} = await this.$axios.$post(state.REST_URL.user, admParam, {loading: false, loadingHide: false, successAlert: false})
        if (code === 'ok') {
          changeIdMapper[key] = result.snmp_cm_user_id
          admParam.snmp_cm_user_id = result.snmp_cm_user_id
          delete admParam.snmp_cm_user_auth_pw
          delete admParam.snmp_cm_user_enc_pw
          newSnmpUserList.push(admParam)
        } else {
          commit('setErrorMessage', result)
          res = false
          break
        }
      }
      // state.snmpUserList = _.cloneDeep(newSnmpUserList)
      state.snmpUserPwList = _.map(state.snmpUserPwList, item => {
        const key = _.toString(item.snmp_cm_user_id)
        // item.snmp_cm_user_id = changeIdMapper[key]
        _.set(item, 'snmp_cm_user_id', changeIdMapper[key])
        return item
      })
    }

    if (res && _.size(state.snmpV3SettingList) > 0) {
      for (const param of state.snmpV3SettingList) {
        const key = _.toString(param.snmp_cm_user_id)
        param.snmp_cm_user_id = changeIdMapper[key]
        const {code, result} = await this.$axios.$post(state.REST_URL.v3, _.omit(param, ['itemIndex', '_itemKey']), {loadingShow: false, loadingHide: false, successAlert: false})
        if (code !== 'ok') {
          commit('setErrorMessage', result)
          res = false
          break
        }
      }
    }

    const trapList = _.filter(state.snmpTrapList, item => { return item.snmp_cm_trap_addr_val !== '' })
    if (res && _.size(trapList) > 0) {
      for (const snmpTrapParam of trapList) {
        if (!_.isNull(snmpTrapParam.snmp_cm_user_id)) {
          const key = _.toString(snmpTrapParam.snmp_cm_user_id)
          snmpTrapParam.snmp_cm_user_id = changeIdMapper[key]
        }
        const {code, result} = await this.$axios.$put(state.REST_URL.trap, snmpTrapParam, {loadingShow: false, loadingHide: false, successAlert: false})
        if (code !== 'ok') {
          commit('setErrorMessage', result)
          res = false
          break
        }
      }
    }

    return res
  },
  async edtSnmpTrapUse ({commit, state}, param) {
    try {
      const {code, result} = await this.$axios.$post(`${state.REST_URL.trap}/multi`, param, {loading: false, isNotAlert: true})
      if (code === 'ok') {
        return true
      }
      commit('setErrorMessage', result)
    } catch (e) {}
    return false
  },
  async resetInit ({commit, state}, id) {
    try {
      const {code} = await this.$axios.put(`${state.url}/reset`, {
        snmp_cm_id: id
      }, {loading: false, isNotAlert: true})
      if (code === 'ok') {
        return true
      }
    } catch (e) {}
    return false
  },
  async finalCommand ({state}, type) {
    const axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
    const {code} = await this.$axios.$put(`${state.url}/${type}`, void 0, axiosConfig)
    if (code === 'ok') {
      return true
    }
    return false
  }
}

export const getters = {
  getLogData (state) {
    return chgLogInfo(state.snmpPageData.snmp_cm_log_set)
  }
}

export const strict = false

function chgLogInfo (logData) {
  const logInfo = []
  _.forEach(logData, (dInfo) => {
    const info = _.assignIn({key: dInfo.log_id, title: `cm.mailServer_popup_dataTable_${_.camelCase(dInfo.name)}`, level: 1, disable_use: 0}, dInfo)
    if (_.size(logInfo) === 0 || _.isUndefined(_.find(logInfo, {key: dInfo.mod_id, level: _.isNil(dInfo.level) ? 0 : (dInfo.level - 1)}))) {
      logInfo.push(_.assignIn(
        { key: dInfo.mod_id,
          title: `cm.mailServer_popup_dataTable_${dInfo.mod_id}`,
          level: 0,
          children: [info],
          disable_use: 0
        },
        _.omit(dInfo, ['mode_id', 'name']))
      )
    } else {
      const fIdx = _.findIndex(logInfo, {key: dInfo.mod_id, level: _.isNil(dInfo.level) ? 0 : dInfo.level - 1})
      logInfo[fIdx].children.push(info)
      // 다른 log가 1이 아닐 경우 부모 log도 0으로 설정.
      if (info.snmptrap1_use !== 1) {
        logInfo[fIdx].snmptrap1_use = 0
      }
      if (info.snmptrap2_use !== 1) {
        logInfo[fIdx].snmptrap2_use = 0
      }
      if (info.snmptrap3_use !== 1) {
        logInfo[fIdx].snmptrap3_use = 0
      }
    }
  })
  return logInfo
}
